import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomerReplyPortalTicketModel } from '../models/customer-reply-portal-ticket-model.model';
import { environment } from '@environment';
import { CustomerReplyPortalReplyModel } from '../models/customer-reply-portal-reply-model.model';
import { CustomerReplyPortalReplyModelBody } from '../models/customer-reply-portal-reply-model-body.model';

@Injectable({
    providedIn: 'root',
})
export class CustomerReplyPortalService {
    constructor(private httpClient: HttpClient) {}

    addReply(newReply: CustomerReplyPortalReplyModelBody): Observable<CustomerReplyPortalReplyModel> {
        return this.httpClient.post<CustomerReplyPortalReplyModel>(
            environment.apiInboxUrl + 'customerReplyPortal/Ticket/Replies/',
            newReply,
        );
    }

    getTicket(): Observable<CustomerReplyPortalTicketModel> {
        return this.httpClient.get<CustomerReplyPortalTicketModel>(
            environment.apiInboxUrl + 'customerReplyPortal/Ticket/',
        );
    }
}
